import {
  FETCH_FOOTER,
  FOOTER_ADD_STATUS,
  FOOTER_SAVE_END,
  FOOTER_SAVE_START,
  FOOTER_UPDATE_STATUS
} from '../actionTypes'

const initialState = {
  isSaving: false
}

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_FOOTER:
      return {
        ...state,
        ...action.payload
      }
    case FOOTER_ADD_STATUS:
      return {
        ...state,
        ...action.payload
      }
    case FOOTER_UPDATE_STATUS:
      return {
        ...state,
        ...action.payload
      }
    case FOOTER_SAVE_START:
      return {
        ...state,
        isSaving: true
      }
    case FOOTER_SAVE_END:
      return {
        ...state,
        isSaving: false
      }
    default:
      return state
  }
}
